import React, { useEffect } from 'react';
import { LoginCallback, LogoutCallback, SilentCallback } from './AuthCallback';

// Smart auth handler that detects the type of callback based on URL
export const AuthHandler: React.FC = () => {
  useEffect(() => {
  }, []);

  // Detect callback type from URL
  const detectCallbackType = () => {
    const url = window.location.href.toLowerCase();
    const pathname = window.location.pathname.toLowerCase();
    const search = window.location.search;
    const hash = window.location.hash;
    
    // Check for logout callback
    if (pathname.includes('logout') || url.includes('logout')) {
      return 'logout';
    }
    
    // Check for silent callback  
    if (pathname.includes('silent') || url.includes('silent')) {
      return 'silent';
    }
    
    // Check for login callback (default)
    const hasCode = search.includes('code=') || hash.includes('code=');
    const hasState = search.includes('state=') || hash.includes('state=');
    
    if (hasCode || hasState || pathname.includes('callback')) {
      return 'login';
    }
    
    return 'unknown';
  };

  const callbackType = detectCallbackType();

  // Render appropriate callback component
  switch (callbackType) {
    case 'logout':
      return <LogoutCallback />;
    case 'silent':
      return <SilentCallback />;
    case 'login':
      return <LoginCallback />;
    default:
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-4 border-blue-600 mx-auto"></div>
            <h2 className="mt-4 text-xl font-semibold text-gray-900">
              Processing Login...
            </h2>
            <p className="mt-2 text-gray-600">
              Please wait while we complete your authentication.
            </p>
            
            <button 
              onClick={() => window.location.href = '/'}
              className="mt-6 bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
            >
              Return to Home
            </button>
          </div>
        </div>
      );
  }
};

export default AuthHandler;
